'use strict';

angular.module('app').directive('paymentInfo', function ($rootScope, $compile, gettextCatalog, gettext) {
  return {
    restrict: 'A',
    scope: {
      paymentInfo: '=',
      currency: '=',
      currencyToCharge: '=',
      amountTotal: '=',
    },
    link: function (scope, element) {
      var template = '';

      if (scope.paymentInfo.length === 1) {
        template += '<li ng-class="{finished: paymentInfo[0].isCharged}">' +
                    '{{paymentInfo[0].dateToPay | timezone | translateDate }} - {{::currency}} {{paymentInfo[0].amount | number:2}}' + (scope.currency !== scope.currencyToCharge ? '<sup>*</sup>' : '') + ' - {{ (+paymentInfo[0].amount * 100) / (+amountTotal) | number:0}}% ' + gettextCatalog.getString('balance') +
                    '</li>';
      } else {
        // 2nd payment, 3rd payment etc...
        var paymentText = gettext('nd payment');
        _.each(scope.paymentInfo, function (val, key) {
          if (key === 0) {
            template += '<li ng-class="{finished: ' + val.isCharged + '}">' +
                      '{{"' + val.dateToPay + '"  | timezone | translateDate }} - ' + scope.currency + ' ' + val.amount + (scope.currency !== scope.currencyToCharge ? '<sup>*</sup>' : '') +
                      ' - {{ (+' + val.amount + ' * 100) / (+amountTotal) | number:0 }}% ' + gettextCatalog.getString('down-payment') +
                      '</li>';
          } else if (key !== 0 && scope.paymentInfo.length !== key + 1) {
            template += '<li ng-class="{finished: ' + val.isCharged + '}">' +
                      '{{"' + val.dateToPay + '"  | timezone | translateDate }} - ' + scope.currency + ' ' + val.amount + (scope.currency !== scope.currencyToCharge ? '<sup>*</sup>' : '') +
                    ' - {{ (+' + val.amount + ' * 100) / (+amountTotal) | number:0 }}% {{' + key + ' + 1}}' + paymentText +
                      '</li>';
          } else {
            template += '<li ng-class="{finished: ' + val.isCharged + '}">' +
                      '{{"' + val.dateToPay + '"  | timezone | translateDate }} - ' + scope.currency + ' ' + val.amount + (scope.currency !== scope.currencyToCharge ? '<sup>*</sup>' : '') +
                      ' - {{ (+' + val.amount + ' * 100) / (+amountTotal) | number:0}}% ' + gettextCatalog.getString('balance') +
                      '</li>';
          }
        });
      }
      element.append($compile(template)(scope));
    },
  };
});
